/**
 * Shows the support item component
 */
angular.module('gateApp').component('supportItem', {
  template: require('./support-item.html').default,
  bindings: {
    item: '<',
  },
});
